var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-3 col-sm-6 col-padding text-center animate-box"},[_c('a',{staticClass:"work image-popup",style:({ backgroundImage: `url(${_vm.img})` }),attrs:{"href":_vm.link}},[_c('div',{staticClass:"desc"},[_c('h3',[_vm._v(_vm._s(_vm.name))]),_c('span',[_vm._v(_vm._s(_vm.illus))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }